<template>
	<Row>
		<SIcon :width="14" height="14" class="info-icon mr-2" :name="`${isWarning ? 'warning' : 'successfull'}-connection`" />
		<Row class="message-text">{{ text }}</Row>
	</Row>
</template>
<script>
export default {
	name: 'CredentialsSuggestionsInfoMessage',
	props: { text: { type: String }, isWarning: { type: Boolean, default: false } },
};
</script>
<style scoped lang="scss">
.message-text {
	font-size: 11px;
	letter-spacing: 0px;
	color: var(--primary-font-color);
}
.info-icon {
	margin-top: 1px;
}
</style>
